import { PhoneCall, Loader2 } from "lucide-react";

// Sezione "Numeri utili" del portale: elenco fornitori del condominio con azione "Chiama".
export const PortalNumeri = ({ numeri }) => (
  <div data-testid="portal-numeri-section">
    <h1 className="font-head text-2xl font-extrabold tracking-tight mb-1">Numeri utili</h1>
    <p className="text-sm text-muted-foreground mb-6">Fornitori del tuo condominio che puoi contattare direttamente.</p>
    {numeri === null ? (
      <div className="flex justify-center py-12"><Loader2 className="h-5 w-5 animate-spin text-muted-foreground" /></div>
    ) : numeri.length === 0 ? (
      <div className="text-center py-12 text-muted-foreground flex flex-col items-center gap-3">
        <PhoneCall className="h-9 w-9 opacity-40" />
        Nessun numero utile disponibile al momento.
      </div>
    ) : (
      <div className="space-y-2.5" data-testid="numeri-list">
        {numeri.map((n, i) => (
          <div key={n.id} data-testid={`numero-card-${i}`} className="bg-card border border-border rounded-2xl p-4 flex items-center gap-3">
            <div className="h-11 w-11 rounded-xl bg-[#007BFF]/10 flex items-center justify-center shrink-0"><PhoneCall className="h-5 w-5 text-[#007BFF]" /></div>
            <div className="min-w-0 flex-1">
              <div className="font-semibold tracking-tight truncate">{n.name}</div>
              {n.category && <div className="text-xs text-muted-foreground truncate">{n.category}</div>}
              {n.phone && <div className="text-sm font-mono text-muted-foreground truncate mt-0.5">{n.phone}</div>}
            </div>
            {n.phone ? (
              <a href={`tel:${n.phone.replace(/\s+/g, "")}`} data-testid={`numero-call-${i}`}
                className="shrink-0 inline-flex items-center gap-1.5 bg-[#007BFF] hover:bg-[#0069D9] text-white text-sm font-medium rounded-full px-4 py-2 transition-colors">
                <PhoneCall className="h-4 w-4" />Chiama
              </a>
            ) : (
              <span className="shrink-0 text-xs text-muted-foreground">Nessun numero</span>
            )}
          </div>
        ))}
      </div>
    )}
  </div>
);
